<script lang="ts">
    import { onMount } from 'svelte'

    let className = ''
    export { className as class }
    export let sticky: boolean = false
    export let wrap: boolean = true
    let bar

    let observer
    onMount(() => {
        observer = new IntersectionObserver(
            ([e]) => {
                e.target.classList.toggle('zact_is-pinned', e.intersectionRatio < 1)
            },
            { threshold: 1 },
        )

        observer.observe(bar)
    })
</script>

<div bind:this={bar} class="zact zact_wrap-{wrap} {className}" class:is-sticky={sticky}><slot /></div>

<style>
</style>
